import {
  GET_FILE_REQUIREMENT,
  GET_FILE_REQUIREMENT_SUCCESS,
  GET_FILE_REQUIREMENT_FAIL,
  GET_LIST_AREA_SUCCESS,
  GET_LIST_AREA,
  GET_LIST_AREA_FAIL,
  GET_LIST_FILE_TYPE,
  GET_LIST_FILE_TYPE_SUCCESS,
  GET_LIST_FILE_TYPE_FAIL,
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAIL,
  EDIT_FILE_FAIL,
  EDIT_FILE_SUCCESS,
  EDIT_FILE,
  SAVE_FILE_SUCCESS,
  SAVE_FILE_FAIL,
  SAVE_FILE,
  CLEAN_DATA_FILE,
} from "./actionTypes"

export const getFilesRequirement = filter => {
  return {
    type: GET_FILE_REQUIREMENT,
    payload: { filter },
  }
}
export const getFilesRequirementSuccess = filesLs => ({
  type: GET_FILE_REQUIREMENT_SUCCESS,
  payload: filesLs,
})

export const getFilesRequirementFail = error => ({
  type: GET_FILE_REQUIREMENT_FAIL,
  payload: error,
})

export const getTypesArea = typeId => ({
  type: GET_LIST_AREA,
  payload: typeId,
})

export const getTypesAreaSuccess = types => ({
  type: GET_LIST_AREA_SUCCESS,
  payload: types,
})

export const getTypesAreaFail = error => ({
  type: GET_LIST_AREA_FAIL,
  payload: error,
})

export const getTypesFiles = typeId => ({
  type: GET_LIST_FILE_TYPE,
  payload: typeId,
})

export const getTypesFilesSuccess = types => ({
  type: GET_LIST_FILE_TYPE_SUCCESS,
  payload: types,
})

export const getTypesFilesFail = error => ({
  type: GET_LIST_FILE_TYPE_FAIL,
  payload: error,
})

export const deleteFile = data => {
  return {
    type: DELETE_FILE,
    payload: data,
  }
}
export const deleteFileSuccess = file => ({
  type: DELETE_FILE_SUCCESS,
  payload: file,
})

export const deleteFileFail = error => ({
  type: DELETE_FILE_FAIL,
  payload: error,
})
export const updateFileSuccess = file => ({
  type: EDIT_FILE_SUCCESS,
  payload: file,
})

export const updateFileFail = error => ({
  type: EDIT_FILE_FAIL,
  payload: error,
})
export const updateFile = file => ({
  type: EDIT_FILE,
  payload: file,
})
export const saveFileSuccess = file => ({
  type: SAVE_FILE_SUCCESS,
  payload: file,
})

export const saveFileFail = error => ({
  type: SAVE_FILE_FAIL,
  payload: error,
})
export const saveFile = file => ({
  type: SAVE_FILE,
  payload: file,
})
export const cleanDataFile = file => ({
  type: CLEAN_DATA_FILE,
  payload: file,
})
